module.exports = __webpack_public_path__ + "static/media/default-image.2176cf8f.svg";